import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EstablishmentsForCategorieResponse } from "../../../../establishments-for-categorie/interface/establishments-for-categorie.interface";
import { environment } from "../../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class EstablishmentFavoritesService {
  private readonly apiUrl = environment.apiUrl
  constructor(
    private http: HttpClient,

  ) { }

  getFavoritesEstablishments( latitude:string,longitude:string): Observable<EstablishmentsForCategorieResponse> {
    return this.http.post<EstablishmentsForCategorieResponse>(`${this.apiUrl}/favorite`,{latitude,longitude});
  }
}
